import React, {useEffect, useState} from 'react';

import styled from 'styled-components'

import {Elements, useStripe, useElements} from '@stripe/react-stripe-js';
import {CardElement} from '@stripe/react-stripe-js';


export default function StripeCardInput({onFinish}) {
    // Get States from Redux Store
    const stripe = useStripe();
    const elements = useElements();

    const [loading, setLoading] = useState(false)

    const handleSubmit = async (event) => {
        // Block native form submission.
        if (loading) return
        event.preventDefault();
        setLoading(true)

        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            return;
        }

        // Get a reference to a mounted CardElement. Elements knows how
        // to find your CardElement because there can only ever be one of
        // each type of element.
        const cardElement = elements.getElement(CardElement);

        // Use your card Element with other Stripe.js APIs
        const {error, paymentMethod} = await stripe.createPaymentMethod({
            type: 'card',
            card: cardElement,
        });

        if (error) {
            console.log('[error]', error);
        } else {

            // fetch(
            //     '/ajax/profile/update-payment-method', {
            //         method: 'POST',
            //         headers: [
            //
            //         ],
            //         body: JSON.stringify({id: paymentMethod.id})
            //     }
            // )
            //     .then(() => console.log('update'))

            updatePaymentMethod: async(paymentMethod) => {
                try {
                    await apiPost( 'api/user/update-payment-method', paymentMethod);

                    return true
                } catch (e) {
                    return null;
                }
            }


            if (onFinish) onFinish()

            console.log('[PaymentMethod]', paymentMethod);
        }

        setLoading(false)
    };



    return (
        <Wrapper>
            <WrapperCard>
                <CardElement

                    options={{
                        style: {
                            base: {
                                fontSize: '16px',
                                color: '#FA9F64',
                                '::placeholder': {
                                    color: '#5F676D',
                                },
                            },
                            invalid: {
                                color: '#9e2146',
                            },
                        },
                    }}
                />
            </WrapperCard>
            <ButtonContainer>
            <Button isLoading={loading} color="secondary" disabled={loading} variant="contained" style={{marginTop: '12px'}}
                    onClick={handleSubmit}>{loading ? 'Cargando...' : 'Actualiza tus datos para continuar'}</Button>
            </ButtonContainer>
        </Wrapper>
    );
}

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;

`
const Button = styled.div`
     border: 0.5px solid ${props => props.isLoading ? '#5F676D' : 'white'};
     padding: 16px;
     color: ${props => props.loading ? '#5F676D' : 'white'};
     border-radius: 4px;
     text-align: center;

     &:hover {
          border: 0.5px solid ${props => props.isLoading ? '#5F676D' : '#FA9F6B'};
          background-color: ${props => props.isLoading ? '#5F676D' : '#FA9F6B'};
          color: black;
          cursor: pointer;
     }
`

const Wrapper = styled.div`

`


const WrapperCard = styled.div`
  border-color: #5F676D;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  padding: 16px;
  margin-bottom: 24px;

`
